import { render, staticRenderFns } from "./traceBack.vue?vue&type=template&id=1f3da846&scoped=true"
import script from "./traceBack.vue?vue&type=script&lang=js"
export * from "./traceBack.vue?vue&type=script&lang=js"
import style0 from "./traceBack.vue?vue&type=style&index=0&id=1f3da846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3da846",
  null
  
)

export default component.exports